// Pay Invoice with Ref 

import { CToken } from '../function/axios'

export let cancelCheckInvoice;
let urlToEndpoint = (/^.*\/\/[^\/]+/); //eslint-disable-line


export default {
    checkInvoice : (invoice_id, post_code = null, payment_option = null, token = null) => {
        if (!invoice_id){ return 'error'}

       let payload = payment_option && token ? { invoice_id, post_code, payment_option, 'g_recaptcha_response': token } 
       : payment_option ? { invoice_id, post_code, payment_option } 
       : (token && (!post_code || post_code==="null")) ? { invoice_id, 'g_recaptcha_response': token }
       : token && post_code ? { invoice_id, post_code, 'g_recaptcha_response': token }
      : { invoice_id, post_code };
      

        return window.ccpAxios.post( `/internal/pay-invoice`, payload,{
          cancelToken: new CToken (function(c){
            cancelCheckInvoice  = c
          })
        })
    },
    payInvoice: (_url, payload) => {
        let url;
        if (_url){ url = _url.replace(urlToEndpoint, '')
        } else {return 'error'}
        return window.ccpAxios.post( url, payload,{
          cancelToken: new CToken (function(c){
            cancelCheckInvoice  = c
          })
        })
    },
    successfulPaymentPayPal: (_url, payload) => {
        let url;
        if (_url){ url = _url.replace(urlToEndpoint, '')
        } else {return 'error'}
        return window.ccpAxios.post( url, payload,{
            cancelToken: new CToken (function(c){
              cancelCheckInvoice  = c
            })
        });        
    }
}